module.exports = new __parcel__URL__("antirat_squad_department_level_3.85c5507a.png").toString();